// main.jsx

import "./polyfills";
import { patchNearRpcFetch } from "./patches/nearRpcFetch";
patchNearRpcFetch();
import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import "./i18n";
import "./assets/style.css";
import "./assets/nuvelor-theme.css";
import "./assets/theme-tokens.css";
import App from './App.jsx';
import { ToastProvider } from "./ToastContext";
import { initializeNuvelorTheme } from "./utils/theme";

initializeNuvelorTheme();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ToastProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ToastProvider>
  </StrictMode>
);
